(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["hero-image-block"] && !Shopify.designMode) return;
  try {
    (function () {
    class HeroImage extends HTMLElement {
      constructor() {
        super();
        this.parallaxEnabled = false;
        this.image = null;
      }

      connectedCallback() {
        this.image = this.querySelector('.hero-image');
        this.logoImg = document.querySelector('span[x-html="logo_src"]') || null;

        if (this.image) {
          this.parallaxEnabled = this.image.getAttribute('data-parallax-enabled') === 'true';

          if (this.parallaxEnabled) {
            this.handleParallax = this.handleParallax.bind(this);
            window.addEventListener('scroll', this.handleParallax);
            this.handleParallax();
          }
        }

        if (this.logoImg) {
          this.logoImg.style.opacity = '0';
          this.logoImg.style.transition = 'opacity 0.3s ease';
          this.logoImg.style.pointerEvents = 'none';
          this.onScrollLogo = this.handleLogoVisibility.bind(this);
          window.addEventListener('scroll', this.onScrollLogo);
          this.handleLogoVisibility();
        }
      }

      handleParallax() {
        if (!this.image) return;

        const rect = this.getBoundingClientRect();
        const scrollPercent = (window.innerHeight - rect.top) / (window.innerHeight + rect.height);
        const parallaxOffset = scrollPercent * 100 - 50;

        this.image.style.transform = `translateY(${parallaxOffset * 0.5}px)`;
      }

      handleLogoVisibility() {
        if (!this.logoImg) return;

        const heroRect = this.getBoundingClientRect();
        const heroHeight = heroRect.height;
        const scrolled = Math.abs(heroRect.top);

        if (scrolled >= heroHeight * 0.2) {
          this.logoImg.style.opacity = '1';
          this.logoImg.style.pointerEvents = 'auto';
        } else {
          this.logoImg.style.opacity = '0';
          this.logoImg.style.pointerEvents = 'none';
        }
      }

      disconnectedCallback() {
        if (this.parallaxEnabled) {
          window.removeEventListener('scroll', this.handleParallax);
        }
        if (this.onScrollLogo) {
          window.removeEventListener('scroll', this.onScrollLogo);
        }
      }
    }

    customElements.define('hero-image', HeroImage);
  })();
  } catch(e) { console.error(e); }
})();

})();
